// @ts-ignore
export const toggleSidebar = (state) => {
  state.sidebar = !state.sidebar;
};

// @ts-ignore
export const setSidebar = (state, value) => {
  state.sidebar = value;
};
